var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"inline-block"}},[_c('label',{staticClass:"radio-label"},[_vm._v("单元格自适应宽度: ")]),_c('el-switch',{attrs:{"active-value":"true","inactive-value":"false"},model:{value:(_vm.autoWidth),callback:function ($$v) {_vm.autoWidth=$$v},expression:"autoWidth"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }